import { render, staticRenderFns } from "./OrdersTableEmptyState.vue?vue&type=template&id=cf96e8fc&scoped=true&"
import script from "./OrdersTableEmptyState.vue?vue&type=script&lang=ts&"
export * from "./OrdersTableEmptyState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf96e8fc",
  null
  
)

export default component.exports